import { FaWifi } from "react-icons/fa6";

export const InternetStatus = () => (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: 30, height: 30 }}
    >
      <FaWifi className="text-xl text-green-500 relative z-10" />
      <span className="signal-arc signal-arc-1" />
      <span className="signal-arc signal-arc-2" />
      <style>{`
        .signal-arc {
          position: absolute; bottom: 4px; left: 50%;
          width: 18px; height: 9px;
          border: 2px solid rgba(34, 197, 94, 0.55);
          border-bottom: none; border-radius: 50% 50% 0 0;
          pointer-events: none;
        }
        .signal-arc-1 { animation: signalEmit 2.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite; }
        .signal-arc-2 { animation: signalEmit 2.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.9s infinite; }
        @keyframes signalEmit {
          0%   { opacity: 0.75; transform: translateX(-50%) translateY(0) scaleX(1) scaleY(1); }
          60%  { opacity: 0.2; }
          100% { opacity: 0; transform: translateX(-50%) translateY(-16px) scaleX(2.2) scaleY(2.5); }
        }
      `}</style>
    </div>
  );
  